import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../Navbar';
import styles from './LegalDocument.module.css';
import { GAUtils } from '../../model/GAUtils';

interface LegalDocumentProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

const LegalDocument: React.FC<LegalDocumentProps> = ({ title, lastUpdated, children }) => {
  // Track page view on mount
  useEffect(() => {
    const pageName = title.toLowerCase().replace(/\s+/g, '_');
    GAUtils.trackPageView(pageName, `${title} - XTEA`);
  }, [title]);

  return (
    <>
      <Helmet>
        <title>{title} - XTEA</title>
        <meta name="description" content={`${title} for XTEA Telegram Search Engine. Read our ${title.toLowerCase()} to understand how we operate.`} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://xtea.app/${title.toLowerCase().replace(/\s+/g, '-')}`} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={`${title} - XTEA`} />
        <meta property="og:description" content={`${title} for XTEA Telegram Search Engine.`} />
        <meta property="og:site_name" content="XTEA" />
      </Helmet>
      
      <Navbar />

      <div className={styles.container}>
        <div className={styles.content}>
          <h1>{title}</h1>
          <p className={styles.lastUpdated}>Last Updated: {lastUpdated}</p>
          {children}
        </div>
      </div>
    </>
  );
};

export default LegalDocument; 